import { useState, useEffect } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useCanAccess } from '../../hooks/useCanAccess'
import { useBuildingStore } from '../../stores/buildingStore'
import { useViewStore } from '../../stores/viewStore'
import { siteApi } from '../../services/siteApi'

export default function IFCRotationSlider() {
  const canUpdate = useCanAccess('sites', 'update')
  const currentSiteId = useBuildingStore((s) => s.currentSiteId)
  const sites = useBuildingStore((s) => s.sites)
  const setIfcRotation = useViewStore((s) => s.setIfcRotation)

  const currentSite = sites.find((s) => s.id === currentSiteId)
  const [rotation, setRotation] = useState(0)
  const [saved, setSaved] = useState(false)

  useEffect(() => {
    if (currentSite?.ifc_rotation !== undefined && currentSite.ifc_rotation !== null) {
      setRotation(currentSite.ifc_rotation)
      setIfcRotation(currentSite.ifc_rotation)
    } else {
      setRotation(0)
      setIfcRotation(0)
    }
  }, [currentSite, setIfcRotation])

  const saveMutation = useMutation({
    mutationFn: () => siteApi.updateSite(currentSiteId!, { ifc_rotation: rotation }),
    onSuccess: () => {
      setSaved(true)
      setTimeout(() => setSaved(false), 2000)
    },
  })

  if (!canUpdate || !currentSiteId) return null

  return (
    <div className="ifc-rotation">
      <div className="panel-section__title">Rotation IFC</div>
      <div className="ifc-rotation__control">
        <input
          type="range"
          min="-180"
          max="180"
          step="1"
          value={rotation}
          onChange={(e) => {
            const val = parseInt(e.target.value)
            setRotation(val)
            setIfcRotation(val)
          }}
          className="ifc-rotation__slider"
        />
        <span className="ifc-rotation__value">{rotation}°</span>
      </div>
      <button
        className="ifc-rotation__save"
        onClick={() => saveMutation.mutate()}
        disabled={saveMutation.isPending}
      >
        {saveMutation.isPending ? 'Sauvegarde...' : saved ? 'Sauvegarde !' : 'Sauvegarder rotation'}
      </button>
    </div>
  )
}
